import { BOLD } from 'vendor/ckeditor/plugins/bold';
import { CODE_BLOCK } from 'vendor/ckeditor/plugins/code-block';
import { ITALIC } from 'vendor/ckeditor/plugins/italic';
import { BULLETED_LIST, NUMBERED_LIST } from 'vendor/ckeditor/plugins/list';
import { STRIKETHROUGH } from 'vendor/ckeditor/plugins/strikethrough';

export const toolbar = [
  BOLD,
  ITALIC,
  STRIKETHROUGH,
  '|',
  BULLETED_LIST,
  NUMBERED_LIST,
  'link',
  CODE_BLOCK,
];
